import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, FormControlLabel, Checkbox, Button } from '@mui/material';
import { setNotificationDays } from '../utils/api';

const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const dayTranslations = {
    'Sunday': 'יום ראשון',
    'Monday': 'יום שני',
    'Tuesday': 'יום שלישי',
    'Wednesday': 'יום רביעי',
    'Thursday': 'יום חמישי',
    'Friday': 'יום שישי',
    'Saturday': 'יום שבת'
};

const SetTrainingAlertModal = ({ open, onClose, currentDays, userId }) => {
    const [selectedDays, setSelectedDays] = useState(currentDays || []);

    useEffect(() => {
        setSelectedDays(currentDays || []);
    }, [currentDays]);

    const handleDayChange = (day) => {
        setSelectedDays((prev) =>
            prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
        );
    };

    const handleSave = async () => {
        try {
            await setNotificationDays(userId, selectedDays);
            onClose();
        } catch (error) {
            console.error('Error setting notification days:', error);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                dir="rtl"
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    p: 4,
                    width: 400,
                    fontFamily: 'GveretLevin',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <Typography
                    sx={{
                        fontFamily: 'GveretLevin',
                        fontSize: { lg: '44px', xs: '30px' },
                        opacity: 0.7,
                        textAlign: 'right',
                        color: '#B5A78A',
                    }}
                    variant="h6"
                >
                    ימי התראות לאימונים
                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    {daysOfWeek.map((day) => (
                        <FormControlLabel
                            key={day}
                            control={
                                <Checkbox
                                    checked={selectedDays.includes(day)}
                                    onChange={() => handleDayChange(day)}
                                    sx={{
                                        '&.Mui-checked': {
                                            color: '#C4A484',
                                        },
                                    }}
                                />
                            }
                            label={dayTranslations[day]}
                        />
                    ))}
                </Box>
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: "#C4A484",
                        "&:hover": { backgroundColor: "#C4A484" },
                        fontFamily: 'GveretLevin'
                    }}
                    onClick={handleSave}
                >
                    שמור
                </Button>
            </Box>
        </Modal>
    );
};

export default SetTrainingAlertModal;